'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { pushToDataLayer } from '@/utils/helpers'

export default function PageTracking() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const url =
      pathname + (searchParams?.toString() ? `?${searchParams}` : '')

    // PAGE VIEW
    /* pushToDataLayer({
      event: 'page_view',
      page: url,
      page_location: window.location.href,
      page_title: document.title
    }) */

    // EXIT / HIDDEN
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        pushToDataLayer({
          event: 'possible_exit',
          page: url
        })
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [pathname, searchParams])

  return null
}